import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

const EditReservationModal = ({ reservation, onClose, onSave, timeSlots }) => {
    const [updatedReservation, setUpdatedReservation] = useState({
        ...reservation,
        customer: { ...reservation.customer },
    });

    useEffect(() => {
        setUpdatedReservation({
            ...reservation,
            customer: { ...reservation.customer },
        });
    }, [reservation]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setUpdatedReservation((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleCustomerChange = (e) => {
        const { name, value } = e.target;
        setUpdatedReservation((prev) => ({
            ...prev,
            customer: {
                ...prev.customer,
                [name]: value,
            },
        }));
    };

    const handleTimeSlotChange = (e) => {
        const { value } = e.target;
        setUpdatedReservation((prev) => ({
            ...prev,
            reservationTime: value,
        }));
    };

    const handleSave = () => {
        onSave(updatedReservation);
    };

    const openTimeSlots = timeSlots.filter(slot => slot.isOpen);

    // Helper function to format time
    const formatTime = (time) => {
        const [hours, minutes] = time.split(':');
        return `${hours.padStart(2, '0')}:${minutes.padStart(2, '0')}`;
    };

    return (
        <div className="modal fade show" style={{ display: 'block' }}>
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Reservering Bewerken</h5>
                        <button type="button" className="btn-close" onClick={onClose}></button>
                    </div>
                    <div className="modal-body">
                        <div className="mb-3">
                            <label className="form-label">Voornaam</label>
                            <input
                                type="text"
                                className="form-control"
                                name="firstName"
                                value={updatedReservation.customer.firstName}
                                onChange={handleCustomerChange}
                            />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">Achternaam</label>
                            <input
                                type="text"
                                className="form-control"
                                name="lastName"
                                value={updatedReservation.customer.lastName}
                                onChange={handleCustomerChange}
                            />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">Email</label>
                            <input
                                type="email"
                                className="form-control"
                                name="email"
                                value={updatedReservation.customer.email}
                                onChange={handleCustomerChange}
                            />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">Telefoonnummer</label>
                            <input
                                type="text"
                                className="form-control"
                                name="phoneNumber"
                                value={updatedReservation.customer.phoneNumber}
                                onChange={handleCustomerChange}
                            />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">Bedrijfsnaam</label>
                            <input
                                type="text"
                                className="form-control"
                                name="companyName"
                                value={updatedReservation.companyName}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">Datum</label>
                            <input
                                type="date"
                                className="form-control"
                                name="reservationDate"
                                value={updatedReservation.reservationDate}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">Tijd</label>
                            <select
                                className="form-select"
                                name="reservationTime"
                                value={updatedReservation.reservationTime}
                                onChange={handleTimeSlotChange}
                            >
                                <option value="">{formatTime(updatedReservation.reservationTime)}</option>
                                {openTimeSlots.map((slot, index) => (
                                    <option key={index} value={slot.startTime}>
                                        {formatTime(slot.startTime)}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="mb-3">
                            <label className="form-label">Aantal Personen</label>
                            <input
                                type="number"
                                className="form-control"
                                name="numberOfGuests"
                                value={updatedReservation.numberOfGuests}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">Speciale Verzoeken</label>
                            <textarea
                                className="form-control"
                                name="specialRequests"
                                value={updatedReservation.specialRequests}
                                onChange={handleChange}
                            />
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-primary" onClick={handleSave}>Opslaan</button>
                        <button type="button" className="btn btn-secondary" onClick={onClose}>Annuleren</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EditReservationModal;
